import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMuiSelectOption } from "../components/framework/muiAutocomplete2";
import { getCostCenterItems } from "../services/costCenterService";
import { Base } from "../framework/base";
import { t } from "i18next";

export interface CostCenterState {
    groupedOptions: IMuiSelectOption[];
}

export const initialState: CostCenterState = {
    groupedOptions: null,
};

export const costCenterSlice = createSlice({
    name: "costCenter",
    initialState,
    reducers: {
        setGroupedOptions: (
            state,
            action: PayloadAction<IMuiSelectOption[]>
        ) => {
            state.groupedOptions = action.payload;
        },
    },
});

export const { setGroupedOptions } = costCenterSlice.actions;

export const fetchGroupedCostCenterOptions = createAsyncThunk(
    "costCenter/groupedOptions",
    async(_, thunkApi) => {
        const costCenters = await getCostCenterItems(
            1000,
            1,
            "",
            "name",
            true,
            false
        );

        const withGroup = costCenters.items
            .map((i) => ({
                value: i.id,
                label: i.name,
                group: i.customerName,
            }))
            .sort((a, b) =>
                // Sort first so internal cost centers are first.
                Base.stringCompare(a.group, b.group)
            )
            .map((i) => ({
                ...i,
                // Add label for internal cost centers after sorting.
                group: i.group || t("costCenter.internal"),
            }));

        thunkApi.dispatch(setGroupedOptions(withGroup));
    }
);

export const costCenterReducer = costCenterSlice.reducer;
